import { ArrowUpThickIcon } from './ArrowUpThickIcon';

/**
 * author: Austin Andrews
 * id 4EDBF232-461F-4F4C-82BB-64A89BA08405
 * name arrow-up-thick
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-up-thick.svg
 * tags
 * - Arrow 
 */
export const ArrowTopThickIcon = ArrowUpThickIcon;
export default ArrowTopThickIcon